import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const preventTextInput = (value: string) => {
  return value.replace(/\D/g, "")
}

export const getCleanPhoneNumber = (phoneNumber?: string | null) => {
  if (!phoneNumber || (phoneNumber.length === 1 && phoneNumber.startsWith("+"))) {
    return ""
  }
  if (phoneNumber.length > 1 && !phoneNumber.startsWith("+")) {
    return `+${phoneNumber}`
  }
  return phoneNumber
}

export const coveragePrimaryPriority = (isPrimary: boolean) => (isPrimary ? 0 : 1)

// The code below handles errors for the general case:
// [key]: {
//    [some_fields]: null
//    errors: [
//      { message: "error message" }
//    ]
// }
export type GraphqlErrors = ReadonlyArray<{ __typename: string; message: string }>
export const extractGraphqlErrors = (response: Record<string, unknown>): GraphqlErrors =>
  Object.values(response)
    .filter(
      (responseEntry): responseEntry is { errors: GraphqlErrors } =>
        typeof responseEntry === "object" &&
        responseEntry !== null &&
        "errors" in responseEntry &&
        Array.isArray(responseEntry.errors),
    )
    .flatMap((responseEntry) => responseEntry.errors)
